var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',[_vm._v(" "+_vm._s(_vm.field.label)+" "),(_vm.field.rules.required)?[_vm._v("*")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }